module.exports = __webpack_public_path__ + "assets/img/info2.7ab11bca.png";